import { render, staticRenderFns } from "./movehouse.vue?vue&type=template&id=3bfb6656&scoped=true&"
import script from "./movehouse.vue?vue&type=script&lang=js&"
export * from "./movehouse.vue?vue&type=script&lang=js&"
import style0 from "./movehouse.vue?vue&type=style&index=0&id=3bfb6656&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfb6656",
  null
  
)

export default component.exports